import { render } from "./DataCollectionRow.vue?vue&type=template&id=13443ec1"
import script from "./DataCollectionRow.vue?vue&type=script&lang=js"
export * from "./DataCollectionRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__